"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cosDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var cosDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createCos: _factoriesAny.createCos
};
exports.cosDependencies = cosDependencies;